module.exports = __webpack_public_path__ + "static/media/maqam1.6672bca9.jpeg";